const glideSubmenu =[
    {title: '4', onClick: undefined}
    ,
    {title: '5', onClick: undefined}
    ,
    {title: '3', onClick: undefined}
    ,
    {title: '6', onClick: undefined}
    ,
    {title: '1', onClick: undefined}
    ,
    {title: '2', onClick: undefined}
    ,
    {title: '0', onClick: undefined}
    ,
    {title: '5.5', onClick: undefined}
    ,
    {title: '1.5', onClick: undefined}
    ,
    {title: '3.5', onClick: undefined}
    ,
    {title: '2.5', onClick: undefined}
    ,
    {title: '7', onClick: undefined}
    ,
    {title: '4.5', onClick: undefined}
    ]

    const turnSubmenu = [
        {title: '-2', onClick: undefined}
        ,
        {title: '2', onClick: undefined}
        ,
        {title: '-1', onClick: undefined}
        ,
        {title: '0', onClick: undefined}
        ,
        {title: '-1.5', onClick: undefined}
        , 
        {title: '-4', onClick: undefined}
        , 
        {title: '-3', onClick: undefined}
        ,
        {title: '-0.5', onClick: undefined}
        , 
        {title: '1', onClick: undefined}
        , 
        {title: '0.5', onClick: undefined}
        ,
        {title: '-5', onClick: undefined}
        ,
        {title: '-3.5', onClick: undefined}
        , 
        {title: '-2.5', onClick: undefined}
        ,
        {title: '-4.5', onClick: undefined}
        ,
        {title: '0.05', onClick: undefined}
    ]

    const fadeSubmenu = [
        {title: '2', onClick: undefined}
    ,
    {title: '3', onClick: undefined}
    , 
    {title: '4', onClick: undefined}
    ,
    {title: '1', onClick: undefined}
    ,
    {title: '0', onClick: undefined}
    ,
    {title: '0.5', onClick: undefined}
    ,
    {title: '2.5', onClick: undefined}
    ,
    {title: '1.5', onClick: undefined}
    ,
    {title: '5', onClick: undefined}
    ,
    {title: '3.5', onClick: undefined}
    ,
    {title: '4.5', onClick: undefined}
    ,
    {title: '6', onClick: undefined}
    ]

    const stabilitySubmenu = [
        {title: 'Understable', onClick: 'understable'}
        ,
        {title: 'Stable', onClick: 'stable'}
        ,
        {title: 'Overstable', onClick: 'overstable'}
        , 
        {title: 'Very Overstable', onClick: 'very-overstable'}
        ,
        {title: 'Very Understable', onClick: 'very-understable'}
    ]

    const brandSubmenu =[

    {title: 'Lightning', onClick: 'lightning'}
    ,
    {title: 'Prodigy', onClick: 'prodigy'}
    ,
    {title: 'Storm', onClick: 'storm'}
    ,
    {title: 'Wild Discs', onClick: 'wild-discs'}
    ,
    {title: 'Westside Discs', onClick: 'westside-discs'}
    ,
    {title: 'Innova', onClick: 'innova'}
    ,
    {title: 'Legacy', onClick: 'legacy'}
    , 
    {title: 'DGA', onClick: 'dga'}
    ,
    {title: 'Dynamic Discs', onClick: 'dynamic-discs'}
    ,
    {title: 'Daredevil Discs', onClick: 'daredevil-discs'}
    ,
    {title: 'Axiom Discs', onClick: 'axiom-discs'}
    ,
    {title: 'Infinite Discs', onClick: 'infinite-discs'}
    ,
    {title: 'Other', onClick: 'other'}
    ,
    {title: 'Mint Discs', onClick: 'mint-discs'}
    ,
    {title: 'Thought Space Athletics', onClick: 'thought-space-athletics'}
    ,
    {title: 'MVP', onClick: 'mvp'}
    ,
    {title: 'Discraft', onClick: 'discraft'}
    ,
    {title: 'Latitude 64', onClick: 'latitude-64'}
    ,
    {title: 'Gateway', onClick: 'gateway'}
    ,
    {title: 'Millennium', onClick: 'millennium'}
    ,
    {title: 'Vibram', onClick: 'vibram'}
    ,
    {title: 'Lone Star Discs', onClick: 'lone-star-discs'}
    ,
    {title: 'Streamline', onClick: 'streamline'}
    ,
    {title: 'Discmania', onClick: 'discmania'}
    ,
    {title: 'Viking', onClick: 'viking'}
    , 
    {title: 'Above Ground Level', onClick: 'above-ground-level'}
    , 
    {title: 'Kastaplast', onClick: 'kastaplast'}
    , 
    {title: 'Clash Discs', onClick: 'clash-discs'}
    , 
    {title: 'Yikun', onClick: 'yikun'}
    ,
    {title: 'Løft Discs', onClick: 'løft-discs'}
    , 
    {title: 'Crosslap', onClick: 'crosslap'}
    ,
    {title: 'Disctroyer', onClick: 'disctroyer'}
    ,
    {title: 'AquaFlight', onClick: 'aquaflight'}
    ,
    {title: 'Prodiscus', onClick: 'prodiscus'}
    ,
    {title: 'RPM', onClick: 'rpm'}
    ,
    {title: 'EV-7', onClick: 'ev-7'}
    ,
    {title: 'Disc Golf UK', onClick: 'disc-golf-uk'}
    ]

    const categorySubmenu = [
        {title: 'Control Driver', onClick: 'control-driver'}
    ,
        {title: 'Putter', onClick: 'putter'}
    ,
        {title: 'Approach', onClick: 'approach'}
    ,
        {title: 'Midrange', onClick: 'midrange'}
    ,
        {title: 'Distance Driver', onClick: 'distance-driver'}
    ,
        {title: 'Hybrid Driver', onClick: 'hybrid-driver'}
    ,
        {title: 'Disc Golf Sets', onClick: 'disc-golf-sets'}
    ]

    const speedSubmenu = [
        {title: '6', onClick: undefined}
    ,
        {title: '8', onClick: undefined}
    ,
        {title: '7', onClick: undefined}
    ,
        {title: '3', onClick: undefined}
    ,
        {title: '5', onClick: undefined}
    ,
        {title: '13', onClick: undefined}
    , 
        {title: '2', onClick: undefined}
    ,
        {title: '9', onClick: undefined}
    ,
        {title: '14', onClick: undefined}
    ,
        {title: '4', onClick: undefined}
    ,
        {title: '10', onClick: undefined}
    ,
        {title: '11', onClick: undefined}
    ,
        {title: '12', onClick: undefined}
    ,
        {title: '1', onClick: undefined}
    ,
        {title: '5.5', onClick: undefined}
    , 
        {title: '6.5', onClick: undefined}
    ,
        {title: '3.5', onClick: undefined}
    ,
        {title: '14.5', onClick: undefined}
    ,
        {title: '4.5', onClick: undefined}
    ,
        {title: '15', onClick: undefined}
    ]

     const filterBar = [
        {
            title: 'Brand',
            slug: 'brand',
            submenu:brandSubmenu
        },

        {
            title: 'Category',
            slug: 'category',
            submenu:categorySubmenu
        },

        {
            title: 'Speed',
            slug: 'speed',
            submenu:speedSubmenu 
        },

        {
            title: 'Glide',
            slug: 'glide',
            submenu:glideSubmenu
        },

        {
            title: 'Turn',
            slug: 'turn',
            submenu:turnSubmenu
        },

        {
            title: 'Fade',
            slug: 'fade',
            submenu:fadeSubmenu
        },

        {
            title: 'Stability',
            slug: 'stability',
            submenu:stabilitySubmenu
        }
    ]

const discsArrayAll = false;

    if(discsArrayAll){
    
        const getDetails = (spec) =>{
            let arr = [];
            let arr1 = [];
            let specSubmenu = [];
        
            for(let i = 0; i < discsArrayAll.length; i++){
                if(!arr.includes(discsArrayAll[i][spec])){
                arr.push(discsArrayAll[i][spec])
                arr1.push(discsArrayAll[i][`${spec}_slug`])
                }
                console.log(arr)
            }
        
            for(let i = 0; i < arr.length; i++){
                specSubmenu.push({ 
                    title: arr[i],
                    onClick: arr1[i]
                })
            }
            return specSubmenu;
            }  
    }


    export {filterBar} 